import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface Props {
  message?: string | null;
}

export const RBOStatusErrorAlert = ({ message }: Props) => {
  return (
    <Box
      data-test="rbo-error-alert"
      sx={{
        maxWidth: 850,
        mb: 2,
      }}
    >
      <Alert severity="error">
        <Typography data-test="alert-message">{message}</Typography>
      </Alert>
    </Box>
  );
};
